export const SET_CURRENT_ARTICLE = 'SET_CURRENT_ARTICLE';
export const SET_ARTICLES_LIST = 'SET_ARTICLES_LIST';